import { render, staticRenderFns } from "./TitleInfo.vue?vue&type=template&id=4bb3d36a"
import script from "./TitleInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleInfo.vue?vue&type=style&index=0&id=4bb3d36a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports